'use client';
import { jsx, Fragment, jsxs } from 'react/jsx-runtime';

function AreaGradient({ color, id, withGradient, fillOpacity }) {
  return /* @__PURE__ */ jsx(Fragment, { children: withGradient ? /* @__PURE__ */ jsxs("linearGradient", { id, x1: "0", y1: "0", x2: "0", y2: "1", children: [
    /* @__PURE__ */ jsx("stop", { offset: "0%", stopColor: color, stopOpacity: fillOpacity }),
    /* @__PURE__ */ jsx("stop", { offset: "100%", stopColor: color, stopOpacity: 0.01 })
  ] }) : /* @__PURE__ */ jsx("linearGradient", { id, x1: "0", y1: "0", x2: "0", y2: "1", children: /* @__PURE__ */ jsx("stop", { stopColor: color, stopOpacity: fillOpacity ?? 0.2 }) }) });
}
AreaGradient.displayName = "@mantine/charts/AreaGradient";

export { AreaGradient };
//# sourceMappingURL=AreaGradient.mjs.map
